import React from "react";
import { ArrowRightCircleIcon } from "@heroicons/react/20/solid";
import Product1 from "./assets/images/product_1_1.webp";
import Product2 from "./assets/images/product_2.webp";
import Product3 from "./assets/images/avocats.webp";
import Product4 from "./assets/images/veggies.webp";
import Product5 from "./assets/images/argan.webp";

const sections = [
  {
    title: "Fruits rouges",
    subtitle: "Notre Selection",
    description_begin:
      "Nous sommes fiers de proposer une gamme variée et soigneusement sélectionnée de baies de ",
    description_focus: "baies de haute qualité",
    description_end:
      ", garantissant fraîcheur et saveur pour répondre à tous vos besoins.",
    items: [
      { name: "Fraises", icon: ArrowRightCircleIcon },
      { name: "Framboises", icon: ArrowRightCircleIcon },
      { name: "Myrtilles", icon: ArrowRightCircleIcon },
    ],
    image: Product1,
    color: "text-red-600",
  },
  {
    title: "Agrumes",
    subtitle: "Notre Selection",
    description_begin: "Notre sélection minutieusement choisie d'",
    description_focus: "agrumes premium",
    description_end:
      " vous offre le meilleur en termes de fraîcheur et de qualité, parfaitement adaptée pour répondre à tous vos besoins.",
    items: [
      { name: "Oranges", icon: ArrowRightCircleIcon },
      { name: "Citrons", icon: ArrowRightCircleIcon },
      { name: "Pamplemousses", icon: ArrowRightCircleIcon },
    ],
    image: Product2,
    color: "text-orange-500",
  },
  {
    title: "Avocats",
    subtitle: "Notre Selection",
    description_begin: "Nos ",
    description_focus: "avocats premium",
    description_end:
      ", rigoureusement sélectionnés, offrent une qualité supérieure et une fraîcheur optimale, parfaitement adaptés aux exigences du marché international.",
    items: [{ name: "Avocats Hass", icon: ArrowRightCircleIcon }],
    image: Product3,
    color: "text-green-600",
  },
  {
    title: "Légumes",
    subtitle: "Notre Selection",
    description_begin: "Nous sommes fiers de proposer une gamme variée de ",
    description_focus: "légumes frais",
    description_end:
      ", soigneusement sélectionnés, garantissant une qualité optimale et une fraîcheur incomparable pour satisfaire les besoins de nos clients internationaux.",
    items: [
      { name: "Tomates", icon: ArrowRightCircleIcon },
      { name: "Concombres", icon: ArrowRightCircleIcon },
      { name: "Carottes", icon: ArrowRightCircleIcon },
      { name: "Choux", icon: ArrowRightCircleIcon },
    ],
    image: Product4,
    color: "text-green-700",
  },
  {
    title: "Produits Terroirs",
    subtitle: "Notre selection",
    description_begin:
      "Sélectionnés avec soin pour leur authenticité et leur qualité, ",
    description_focus: "nos produits terroirs",
    description_end:
      " représentent l'excellence des meilleures récoltes, idéaux pour l'exportation à l'international.",
    items: [
      { name: "Argan", icon: ArrowRightCircleIcon },
      { name: "Plantes médicinales", icon: ArrowRightCircleIcon },
    ],
    image: Product5,
    color: "text-yellow-600",
  },
];

const FeaturesSection = () => {
  return (
    <div id="products" className="overflow-hidden bg-white">
      <div className="flex items-center justify-center space-x-4 mt-8">
        <div className="h-0.5 bg-[#69B578] w-16"></div>
        <h1 className="text-3xl text-gray-900 dark:text-white md:text-5xl lg:text-6xl">
          <span className="text-transparent bg-clip-text bg-gradient-to-r to-[#69B578] from-[#9ec083]">
            Nos produits
          </span>
        </h1>
        <div className="h-0.5 bg-[#69B578] w-16"></div>
      </div>

      {sections.map((section, index) => (
        <div
          key={index}
          className={`py-8 ${index % 2 === 0 ? "" : "bg-gray-100"}`} // Alterne les fonds pour plus de contraste
        >
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div
              className={`flex flex-col-reverse gap-y-16 sm:flex-row sm:items-center ${
                index % 2 === 0 ? "" : "sm:flex-row-reverse"
              }`}
            >
              {/* Texte */}
              <div
                className={`sm:w-1/2 ${
                  index % 2 !== 0 ? "sm:pl-10" : "" // Ajoute du padding-left si le texte est à droite
                }`}
              >
                <div>
                  <h2 className="text-base font-semibold text-gray-600">
                    {section.subtitle}
                  </h2>
                  <p
                    className={`mt-2 text-4xl font-semibold tracking-tight ${section.color} sm:text-5xl`}
                  >
                    {section.title}
                  </p>
                  <p className="mt-6 text-lg text-gray-600">
                    {section.description_begin}
                    <span className={`${section.color}`}>
                      {section.description_focus}
                    </span>
                    {section.description_end}
                  </p>

                  {/* Affichage des items en 2 colonnes sur mobile et 3 colonnes sur tablette et plus */}
                  <div className="flex flex-wrap justify-start gap-6 mt-6">
                    {section.items.map((item, idx) => (
                      <div
                        key={item.name}
                        className="flex items-center space-x-1"
                      >
                        <div className={`h-5 w-5 ${section.color}`}>
                          <item.icon
                            aria-hidden="true"
                            className="h-full w-full"
                          />
                        </div>
                        <dt className="font-semibold text-gray-900">
                          {item.name}
                        </dt>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Image */}
              <div className="sm:w-1/2">
                <img
                  alt={section.title}
                  src={section.image}
                  className="w-full max-w-none rounded-xl shadow-xl ring-1 ring-gray-400/10"
                />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FeaturesSection;